import { App } from 'antd';

let message: ReturnType<typeof App.useApp>['message'];

export function useInitMessage() {
    message = App.useApp().message;
}

export { message };
